<template>
  <div>
    <validation-observer ref="crawlerConfigForm">
      <b-form @submit.prevent=""
        @reset.prevent="resetForm">
        <validation-provider #default="validationContext"
          name="Danh mục"
          rules="required">
          <b-form-group>
            <template #label>
              <label class="d-block font-weight-bolder pb-0">Danh mục <span class="text-danger">*</span></label>
            </template>
            <b-form-input type="text"
              id="name"
              v-model="frmData.name"
              :state="getValidationState(validationContext)"
              placeholder="Nhập..." />
            <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <div class="row">
          <div class="col-6">
            <validation-provider #default="validationContext"
              vid="source_id"
              name="Kênh liên kết"
              rules="required">
              <b-form-group>
                <template #label>
                  <label class="d-block font-weight-bolder pb-0">Kênh liên kết <span class="text-danger">*</span></label>
                </template>
                <v-select v-model="frmData.source_id"
                  :options="dataSource"
                  label="name"
                  :reduce="(val) => val.id"
                  placeholder="--Chọn--"
                  :state="getValidationState(validationContext)" />
                <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col-6">
            <validation-provider #default="validationContext"
              vid="type"
              rules="required">
              <b-form-group>
                <template #label>
                  <label class="d-block font-weight-bolder pb-0">Loại tin <span class="text-danger">*</span></label>
                </template>
                <v-select v-model="frmData.type"
                  :options="dataContentType"
                  label="name"
                  :reduce="(val) => val.id"
                  placeholder="--Chọn--"
                  :state="getValidationState(validationContext)" />
                <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
        </div>
        <b-form-group label=""
          v-slot="{ ariaDescribedby }">
          <b-form-radio-group v-model="frmData.is_link"
            name="radio-inline"
            :aria-describedby="ariaDescribedby"
            @change="showHideDiv()"
            :options="options" />
        </b-form-group>
        <validation-provider #default="validationContext"
          vid="content"
          name="Danh sách liên kết"
          rules="required"
          v-if="frmData.is_link == 1">
          <b-form-group description="Đường link được phân biệt sau dấu ;">
            <template #label>
              <label class="d-block font-weight-bolder pb-0">Danh sách liên kết <span class="text-danger">*</span></label>
            </template>
            <b-form-textarea id="textarea"
              v-model="frmData.link"
              placeholder="https://edition.cnn.com/sport/motorsport; https://edition.cnn.com"
              rows="3"></b-form-textarea>
            <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <b-form-group v-else>
          <template #label>
            <label class="d-block font-weight-bolder pb-0">Thông tin tài khoản</label>
          </template>
          <div class="row">
            <div class="col-6">
              <validation-provider #default="validationContext"
                vid="content"
                name="Tài khoản"
                rules="required">
                <b-form-input type="text"
                  id="username"
                  v-model="frmData.config.username"
                  :state="getValidationState(validationContext)"
                  placeholder="Username..." />
                <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <div class="col-6">
              <validation-provider #default="validationContext"
                vid="passowrd"
                name="Mật khẩu"
                rules="required">
                <b-form-input type="text"
                  id="passowrd"
                  v-model="frmData.config.passowrd"
                  :state="getValidationState(validationContext)"
                  placeholder="Mật khẩu..." />
                <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <div class="col-12 mt-1">
              <validation-provider #default="validationContext"
                vid="url"
                name="Link api"
                rules="required">
                <b-form-input type="text"
                  v-model="frmData.config.url"
                  :state="getValidationState(validationContext)"
                  placeholder="Link api" />
                <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>
        </b-form-group>
        <b-form-checkbox v-model="frmData.status"
          value="1"
          class="custom-control-primary"> Kích hoạt </b-form-checkbox>
        <div class="d-flex mt-2">
          <b-button variant="primary"
            type="submit"
            @click.prevent="validationForm"> {{ $t('Save') }} </b-button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { required, email, alphaNum, min, max, } from '@validations'
import store from '@/store'
import { ref, watch } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormCheckbox,
  BFormCheckboxGroup, BFormTextarea, BIconArrowDown, BInputGroup, BInputGroupAppend, BFormRadioGroup
} from 'bootstrap-vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import { showToast, useRouter } from '@core/utils/utils';
import vSelect from 'vue-select'
export default {

  components: {
    vSelect,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BInputGroup,
    BFormTextarea,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormCheckboxGroup,
    BIconArrowDown,
    BInputGroupAppend,
    BFormRadioGroup
  },
  data() {
    return {
      tags_link: '',
      selected: 1,
      options: [
        { text: 'Bóc tách nội dung html', value: 1 },
        { text: "Kết nối thông qua api", value: 2 },
      ],
    }
  },
  props: {
    dataEdit: {
      type: Object,
      default: null
    }
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const blankData = {
      name: '',
      source_id: 0,
      link: '',
      is_link: 1,
      config: {
        username: '',
        password: '',
        url: ''
      },
      type: 'news',
      status: 0
    }

    const frmData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData))
    }
    if (Object.keys(props.dataEdit).length > 0) {
      frmData.value = props.dataEdit
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)
    const dataContentType = [
      { 'id': 'news', 'name': "Tin tức" },
      { 'id': 'video', 'name': "Video" },
      { 'id': 'audio', 'name': "Audio" }
    ];
    const dataSource = [
      { 'id': "1", 'name': "TTXVN" },
      { 'id': "2", 'name': "CNN" },
      { 'id': "3", 'name': "FACEBOOK" },
    ]
    return {
      frmData,
      refFormObserver,
      resetForm,
      getValidationState,
      resetfrmData,
      dataContentType,
      dataSource
    }
  },
  methods: {

    addLink() {
      if (this.tags_link) {
        let tlink = this.tags_link.trim();
        if (!this.frmData.link.includes(tlink)) {
          this.frmData.link.push(tlink);
        } else {
          showToast('Liên kết đã tồn tại')
        }
        this.link = ''
      } else {
        showToast('Nhập liên kết cần thu thập')
      }
    },
    onSubmit() {
      let id = this.frmData.id;
      if (id) {
        store.dispatch('crawlerConfig/update', { data: this.frmData, id: id })
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.resetfrmData()
              this.$emit('updateList')
            }
          })
      } else {
        store.dispatch('crawlerConfig/create', this.frmData)
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.resetfrmData()
              this.$emit('updateList')
            }
          })
      }
    },
    validationForm() {
      this.errorMessage = {}

      this.$refs.crawlerConfigForm.validate().then(success => {
        if (success) {
          this.onSubmit();
        }
      })
    },
  }
}
</script>
<style lang="scss">
.tags_div {
  border: 0 !important;
  padding: 0px;

  &:focus {
    box-shadow: none
  }
}

.tags_link {
  padding: 0;
  margin: 10px 0 0 0;

  li {
    padding: 5px 0 0 0;
    display: block;

    span {
      font-weight: bold;
    }
  }

  .w5 {
    justify-content: space-between;
    display: inline;
  }
}

.b-form-tags.focus {
  box-shadow: none !important;
}

@import '@core/scss/vue/libs/vue-select.scss';
</style>